import { PASSWORD_MAX_LENGTH, passwordErrors, passwordMaxLengthError } from '@/consts/auth';

export function validateCPF(cpf) {
  cpf = cpf?.replace(/\D/g, '');
  if (cpf?.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

  let sum = 0;
  let remainder;
  // eslint-disable-next-line no-plusplus
  for (let i = 1; i <= 9; i++) sum += parseInt(cpf?.substring(i - 1, i), 10) * (11 - i);
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cpf?.substring(9, 10), 10)) return false;

  sum = 0;
  // eslint-disable-next-line no-plusplus
  for (let i = 1; i <= 10; i++) sum += parseInt(cpf?.substring(i - 1, i), 10) * (12 - i);
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cpf?.substring(10, 11), 10)) return false;

  return true;
}

export function validateCNPJ(cnpj) {
  const cnpjValue = String(cnpj || '').trim().toUpperCase();

  if (/[^A-Z0-9./-]/.test(cnpjValue)) return false;

  const normalizedCnpj = cnpjValue
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');

  if (
    normalizedCnpj.length !== 14 ||
    !/^[A-Z0-9]{12}\d{2}$/.test(normalizedCnpj) ||
    /^([A-Z0-9])\1{13}$/.test(normalizedCnpj)
  ) {
    return false;
  }

  const calculateDigit = (base, weights) => {
    const sum = weights.reduce((acc, weight, index) => {
      const charValue = base.charCodeAt(index) - 48;
      return acc + charValue * weight;
    }, 0);

    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };

  const firstDigit = calculateDigit(
    normalizedCnpj.slice(0, 12),
    [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  );
  const secondDigit = calculateDigit(
    `${normalizedCnpj.slice(0, 12)}${firstDigit}`,
    [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  );

  return (
    firstDigit === Number(normalizedCnpj.charAt(12)) &&
    secondDigit === Number(normalizedCnpj.charAt(13))
  );
}

export const validatePasswordErrors = (password) => {
  const errors = [];

  const { min, uppercase, lowercase, number, specialChar } = passwordErrors;

  const remove = (field) => {
    let indexToRemove = -1;

    errors.forEach((item, index) => {
      // eslint-disable-next-line no-prototype-builtins
      if (item.hasOwnProperty(field)) {
        indexToRemove = index;
      }
    });

    if (indexToRemove !== -1) {
      errors.splice(indexToRemove, 1);
    }
  };

  // Conta por code point, como o len() do back: um emoji vale 1, não 2.
  const { length } = Array.from(password ?? '');
  const minCondition = length >= 8;
  const upperCaseCondition = password?.match(/[A-Z]/);
  const lowerCaseCondition = password?.match(/[a-z]/);
  const numberCondition = password?.match(/\d/);
  const specialCharCondition = password?.match(/[^a-zA-Z0-9]/);

  if (!minCondition) errors.push({ min });
  if (!upperCaseCondition) errors.push({ uppercase });
  if (!lowerCaseCondition) errors.push({ lowercase });
  if (!numberCondition) errors.push({ number });
  if (!specialCharCondition) errors.push({ specialChar });
  if (length > PASSWORD_MAX_LENGTH) errors.push({ max: passwordMaxLengthError });

  if (minCondition) remove('min');
  if (upperCaseCondition) remove('uppercase');
  if (lowerCaseCondition) remove('lowercase');
  if (numberCondition) remove('number');
  if (specialCharCondition) remove('specialChar');

  return errors;
};

export const getPasswordValidConditions = (value) => {
  const invalidConditions = validatePasswordErrors(value)?.map((error) => Object.values(error)[0]);
  const allConditions = Object.values(passwordErrors);

  const validConditions = allConditions.filter(
    (condition) => !invalidConditions.includes(condition)
  );

  return validConditions;
};
